
import { computed, defineComponent, nextTick, PropType, ref, watch } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { DateKindLabel } from '@/views/dashboard/service/_enum/date-kind'
import { countdownDay, formatTimeStamp } from '@/utils/time'
import { TerminalTypeLabel } from '@/views/dashboard/_enum/terminal-type'
import { ServiceAuthService } from '@/views/dashboard/service/_components/service-auth/service-auth.service'
import TerminalAuth from '@/views/dashboard/_components/terminal-auth/terminal-auth.vue'
import { ServiceList } from '@/views/dashboard/service/my-subscribe/my-subscribe.service'

export default defineComponent({
  components: {
    TerminalAuth,
  },

  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    serviceList: {
      type: Array as PropType<ServiceList[]>,
      default: () => {[]}
    },
    terminalType: {
      type: Array as PropType<number[]>,
      default: () => ([] as number[])
    },
  },

  setup (props, context) {
    const injector = useReflectiveInjector([ServiceAuthService])
    const service = injector.get(ServiceAuthService)

    const terminalSelectNode = ref()
    const isLoading = ref(false)
    const terminalSelectVisible = ref(true)

    function handleClose () {
      context.emit('update:modelValue', false)
    }

    watch(() => props.modelValue, (value) => {
      if (value) {

      }
    })

    return {
      countdownDay,
      DateKindLabel,
      TerminalTypeLabel,
      terminalSelectNode,
      isLoading,
      terminalSelectVisible,
      formatTimeStamp,
      handleClose,
    }
  }
})
